












import { Component, Mixins } from "vue-property-decorator";
import AdminBrandId from "@/mixins/adminBrandId";

@Component({
  components: {
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue")
  }
})
export default class AdminActivityLogs extends Mixins(AdminBrandId) {}
